import headerImg from "../assets/1.jpg";
import "./header.css";

const Header = () => {
  return (
    <div style={{ textAlign: "center", marginBottom: "5px" }}>     
      <img src={headerImg} alt="Dictionary Header" style={{ maxWidth: "100%", height: "auto", maxHeight: "150px" }} />      
    </div>
  );
};

export default Header;
